import api, { ResponseCallback } from '../services/api.service'
import { ConsumedData } from './consumed.api'
import { LocationData } from './location.api'
import { PalletData } from './pallet.api'
import { PurchaseOrderData } from './purchaseOrder.api'
import { ShipOrderData } from './shipOrder.api'
import { UserData } from './user.api'
import { WorkOrderData } from './workOrder.api'

type TransferableType = 'workOrder' |
  'purchaseOrder' |
  'shipOrder' |
  'consumed'

export type TransferType = 'internal' |
  'receiving' |
  'ship' |
  'consumed'

export interface TransferData {
  id: number
  inventoryId: number
  transferableId: number
  palletId: number
  locationId?: number
  createdBy: number
  deletedBy?: number
  transferableType: TransferableType
  bin: string
  latitude?: number
  longitude?: number
  ip: string
  isRollback: string
  deletedAt?: string
  createdAt: string
  type: TransferType
  pallet?: PalletData
  location?: LocationData
  createdUser?: UserData
  transferable?: WorkOrderData |
    PurchaseOrderData |
    ShipOrderData |
    ConsumedData<PalletData>
}

export interface TransferCreateRequest {
  pallet?: number
  location?: number
  bin?: string
  workOrder?: number
  latitude?: number
  longitude?: number
}

export interface TransferBulkRequest {
  pallets?: number[]
  location?: number
  bin?: string
  workOrder?: number
  latitude?: number
  longitude?: number
}

const routes = {
  create: '/transfers',
  bulk: '/transfers/bulk'
}

export default {
  create (
    payload: TransferCreateRequest,
    callback: ResponseCallback<TransferData>
  ) {
    api.post(routes.create, payload, callback)
  },

  bulk (
    payload: TransferBulkRequest,
    callback: ResponseCallback<PalletData[]>
  ) {
    api.post(routes.bulk, payload, callback)
  }
}
